export const ROUTES = {
    demands: {
        overview: '/demands',
        detail: '/demands/:id',
    },
    topics: '/topics',
    userContacts: '/user-contacts',
    bonusSettlements: {
        overview: '/bonus-settlements',
        detail: {
            base: '/bonus-settlements/:id',
            pool: '/bonus-settlements/:id/pool',
        },
        poolDetails: '/bonus-settlements/:id/pool/:customerBonusSettlementId/',
    },
    notifications: '/notifications',
    inquiries: '/inquiries',
    orders: '/orders',
    orderApprovals: '/order-approvals',
    buyAgain: '/buy-again',
};
